import React from 'react';
import { Switch, Route, RouteComponentProps } from 'react-router-dom';

import { MoEventsListContainer } from './list/MoEventsListContainer';
import { MoEventDetailsContainer } from './details/MoEventDetailsContainer';

export const MoEventsRoutes = (props: RouteComponentProps) => {
  const {
    match: { url },
  } = props;

  return (
    <Switch>
      <Route path={url} exact component={MoEventsListContainer} />
      <Route path={`${url}/:eventId`} component={MoEventDetailsContainer} />
    </Switch>
  );
};
